import { LoadingSkeleton } from "shared/components/molecules/LoadingSkeleton";

import { VignetteLoadingSkeletonContainer } from "./styles";

export const VignetteLoadingSkeleton = () => {
  return (
    <VignetteLoadingSkeletonContainer>
      <LoadingSkeleton.Square width="100%" height="100%" />
    </VignetteLoadingSkeletonContainer>
  );
};
